import classNames from "classnames";
import { usePagination } from "react-instantsearch";
import { useClearCatalogLastScrollY } from "@hooks/use-catalog-navigation-hooks";
import Link from "@components/core/Link";
import CatalogPaginationTens from "@components/views/Catalog/CatalogPaginationTens";
import { Button } from "@components/core";

const CatalogPagination = () => {
  const { currentRefinement, nbPages, isFirstPage, isLastPage, refine, createURL } =
    usePagination();
  const clearLastScrollY = useClearCatalogLastScrollY();

  if (!nbPages || nbPages <= 1) return null;

  function applyPage(event, page) {
    event.preventDefault();
    refine(page);

    setTimeout(() => {
      clearLastScrollY();
      window.scrollTo({ top: 0, behavior: "instant" });
    }, 10);
  }

  const displayPrevLink = () => {
    const prevPage = currentRefinement - 1;

    return (
      <Link
        rel="prev"
        href={createURL(prevPage)}
        as="#prev"
        className={classNames(isFirstPage && "disabled-link")}
        onClick={(event) => applyPage(event, prevPage)}
      >
        <Button
          variant="ghost-dark"
          className="bg-white"
          leftIconName="chevron-left"
          disabled={isFirstPage}
        />
      </Link>
    );
  };

  const displayNextLink = () => {
    const nextPage = currentRefinement + 1;

    return (
      <Link
        rel="next"
        href={createURL(nextPage)}
        as="#next"
        onClick={(event) => applyPage(event, nextPage)}
        className={classNames(isLastPage && "disabled-link")}
      >
        <Button
          variant="ghost-dark"
          className="bg-white"
          leftIconName="chevron-right"
          disabled={isLastPage}
        />
      </Link>
    );
  };

  const displayLastPage = () => {
    if (currentRefinement >= nbPages - 3) return null;

    return (
      <>
        ...
        <Link href={createURL(nbPages - 1)}>{nbPages.toString()}</Link>
      </>
    );
  };

  const displayFirstPage = () => {
    if (currentRefinement < 3) return null;

    return (
      <>
        <Link href={createURL(0)}>1</Link>
        ...
      </>
    );
  };

  return (
    <div className="catalog-pagination mt-5 mb-5 d-flex justify-content-center align-items-center">
      {nbPages > 1 && (
        <>
          {displayPrevLink()}

          <div>
            {currentRefinement + 1}&nbsp;/&nbsp;{nbPages}
          </div>

          <noscript>
            {displayFirstPage()}

            <CatalogPaginationTens />

            {displayLastPage()}
          </noscript>

          {displayNextLink()}
        </>
      )}
    </div>
  );
};

export default CatalogPagination;
